import React, { useRef, useState } from 'react';
import { Modal } from 'antd';

// import '@style/modules/project/termsModal.scss';
import '../../../styles/modules/project/termsModal.scss';
import { connect, useSelector } from 'react-redux';

import { TermsContent } from '../../privacy/terms';
import { CookiesContent } from '../../privacy/cookies';

import actions from '@flux/action';
import { API } from '@service';

// const PRIVACY_HUB_URL =
//   'https://privacyhub.pwc.com/us/en/m-a-gateway/privacy-policy.html';
const PRIVACY_HUB_URL =
  'https://www.pwc.com/us/en/site/privacy.html';

const Content = () => {
  const [chosenContent, chooseContent] = useState('terms');
  const ref = useRef(null);

  const Content = {
    cookies: CookiesContent,
    terms: TermsContent,
  }[chosenContent];

  const onSpanClick = (cType) => () => {
    chooseContent(cType);
    ref.current.scroll({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      <h1>Terms & Conditions</h1>
      <div className="terms-content" ref={ref}>
        <Content />
      </div>
      <p>
        By clicking Accept, you agree to our{' '}
        <span onClick={onSpanClick('terms')}>Terms of Use</span> and that you
        have read our{' '}
        <a
          href={PRIVACY_HUB_URL}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Statement
        </a>
        {/* {' '}
        and{' '}
        <span onClick={onSpanClick('cookies')}>Cookie Statement</span> */}
        .
      </p>
    </div>
  );
};

const TermsModal = ({ logout, visible, onAccept }) => {
  const uid = useSelector((state) => state.login.userInfo?.uid);

  const [isAcceptLoading, setIsAcceptLoading] = useState(false);

  const handleDecline = () => {
    logout();
  };

  const handleAccept = async () => {
    setIsAcceptLoading(true);
    await API.acceptTerms(uid);
    setIsAcceptLoading(false);
    onAccept();
  };

  return (
    <Modal
      wrapClassName="terms-acceptance-modal-v1"
      centered
      confirmLoading={isAcceptLoading}
      closable={false}
      maskClosable={false}
      okText="Accept"
      cancelText="Decline"
      zIndex="135"
      visible={visible}
      destroyOnClose
      maskStyle={{
        background: 'rgba(0,0,0,0.7)',
      }}
      bodyStyle={{
        width: '42.5rem',
        height: '75vh',
      }}
      onCancel={handleDecline}
      onOk={handleAccept}
    >
      <Content />
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    dispatch(actions.logout());
  },
});

export default connect(() => ({}), mapDispatchToProps)(TermsModal);
